export const getLengthDependence = (values: Array<{ controlid: string; value: unknown }>, idDependence: string) => {
	if (!idDependence) {
		return 0;
	}

	const { value } = values?.find((ctrl) => ctrl.controlid === idDependence);

	if (!value) {
		return 0;
	}

	if (Array.isArray(value)) {
		return value.length;
	}

	if (typeof value === "object") {
		return 1;
	}

	return 0;
};
